/**
 * React Query hook for getting specimen count
 */

import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { dataApiClient } from '../client'
import { staticCacheConfig } from '../../../lib/utils'
import type { SpecimenCountRequest, SpecimenCountResponse } from '../'

/**
 * React Query hook for fetching specimen count
 */
export function useSpecimenCount(
  request: SpecimenCountRequest,
  options: Omit<
    UseQueryOptions<SpecimenCountResponse, Error, SpecimenCountResponse, string[]>,
    'queryKey' | 'queryFn'
  > & {
    enabled?: boolean
  } = {}
) {
  return useQuery({
    queryKey: ['specimen-count', JSON.stringify(request.filter_set)],
    queryFn: async (): Promise<SpecimenCountResponse> => {
      const response = await dataApiClient.POST('/specimen/count', {
        body: request,
      })

      if (response.error) {
        throw new Error(`Specimen count request failed: ${response.error}`)
      }

      return response.data
    },
    ...staticCacheConfig,
    ...options,
  })
}
